import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Rnd } from 'react-rnd';
import { Button, Box } from '@material-ui/core';
import { Close } from '@material-ui/icons';
import {
  setAdditionalItemFlg,
} from '../../actions/CompanyAction';
import CompanyAdditionalItemContensComponent from './CompanyAdditionalItemContensComponent';
import {
  ADDITIONAL_ITEM_DISP_SETTINGS,
} from '../../../common/const';
import styles from './CompanyAdditionalItemListComponent.module.css';
import config from '../../../common/config';

class CompanyAdditionalItemListComponent extends Component {
  constructor() {
    super();
    this.state = {
      x: 0,
      y: 0,
      viewSize: {
        width: ADDITIONAL_ITEM_DISP_SETTINGS.MIN_WIDTH,
        height: ADDITIONAL_ITEM_DISP_SETTINGS.MIN_HEIGHT,
      },
    };
  }

  componentDidMount() {
    this.setPopupSize();
    // ウィンドウのリサイズを行った場合、ポップアップのリサイズを行う関数を実行する
    window.addEventListener('resize', () => {
      this.setPopupSize();
    });
  }

  /**
   * 取引情報POPUPを閉じる
   */
  closePopup = () => {
    const { setAdditionalItemFlgAct } = this.props;
    setAdditionalItemFlgAct(false);
  };

  /**
   * ポップアップ画面を移動させるイベント
   */
  onDrag = (e, data) => {
    this.setState({ x: data.x, y: data.y });
  }

  /**
   * ポップアップ画面のサイズを変更するイベント
   */
  onResize = (e, direction, ref, delta, position) => {
    this.setState({
      viewSize: {
        width: ref.style.width,
        height: ref.style.height,
      },
      ...position,
    });
  }

  /**
   * ブラウザのウィンドウの高さ、幅を取得する
   */
  getWindowSize = () => {
    const w = window;
    const doc = document;
    const elem = doc.documentElement;
    const body = doc.getElementsByTagName('titlefield')[0];
    const width = w.innerWidth || elem.clientWidth || body.clientWidth;
    const height = w.innerHeight || elem.clientHeight || body.clientHeight;
    return { width, height };
  }

  /**
   * ブラウザの高さ、幅からポップアップのサイズを計算し、設定する
   */
  setPopupSize = () => {
    const { width, height } = this.getWindowSize();
    // ウィンドウサイズの1/2の幅
    const popupWidth = width * 0.5;
    // ウィンドウサイズから「POSITION_Y」分の余白を上下に持たせた高さ
    const popupHeight = height - ADDITIONAL_ITEM_DISP_SETTINGS.POSITION_Y * 2;
    // ウィンドウの右端から20px余白を持たせた位置
    const positionX = width - popupWidth - 20;
    this.setState({
      x: positionX,
      y: ADDITIONAL_ITEM_DISP_SETTINGS.POSITION_Y,
      viewSize: {
        width: popupWidth,
        height: popupHeight,
      },
    });
  }

  render() {
    const {
      additionalItemFlg,
      setAdditionalItemFlgAct,
      additionalCompany,
      additionalJigyosyo,
      ext001Flg,
      ext002Flg,
    } = this.props;

    const {
      viewSize,
      x,
      y,
    } = this.state;

    // 拡張詳細表示
    let ext001Span = null;
    let ext002Span = null;
    let extDiv = null;
    if (config.TRADE_SEARCH_FLG.FLG1.DISP === '1') {
      ext001Span = (<span>{ext001Flg === '1' ? `${config.TRADE_SEARCH_FLG.FLG1.NAME}${config.TRADE_SEARCH_FLG.FLG1.TRUE}` : `${config.TRADE_SEARCH_FLG.FLG1.NAME}${config.TRADE_SEARCH_FLG.FLG1.FALSE}`}</span>);
    }
    if (config.TRADE_SEARCH_FLG.FLG2.DISP === '1') {
      ext002Span = (<span className={`${styles.space}`}>{ext002Flg === '1' ? `${config.TRADE_SEARCH_FLG.FLG2.NAME}${config.TRADE_SEARCH_FLG.FLG2.TRUE}` : `${config.TRADE_SEARCH_FLG.FLG2.NAME}${config.TRADE_SEARCH_FLG.FLG2.FALSE}`}</span>);
    }
    if (ext001Span || ext002Span) {
      extDiv = (
        <div className={`${styles.tradesearchfield}`}>
          {ext001Span}
          {ext002Span}
        </div>
      );
    }

    return (additionalItemFlg && (
      <div
        className={`${styles.additionalitemlist}`}
        onClick={(ev) => {
          if (ev.target.className === `${styles.additionalitemlist}`) {
            setAdditionalItemFlgAct(false);
          }
        }}
      >

        <Rnd
          className={`${styles.contents}`}
          size={{ width: viewSize.width, height: viewSize.height }}
          position={{ x, y }}
          bounds="parent"
          onDrag={this.onDrag}
          onResize={this.onResize}
          minWidth={`${ADDITIONAL_ITEM_DISP_SETTINGS.MIN_WIDTH}px`}
          minHeight={`${ADDITIONAL_ITEM_DISP_SETTINGS.MIN_HEIGHT}px`}
          cancel={extDiv ? `.${styles.additionalitemcontainer}` : `.${styles.additionalitemcontainernoext}`}
        >
          <div className={extDiv ? `${styles.additionalitemheaderfield} ${styles.extheader}` : `${styles.additionalitemheaderfield}`}>
            <div className={`${styles.titlefield}`}>
              <div className={`${styles.title}`}>
                <span>{additionalCompany}</span>
                <span className={`${styles.space}`}>{additionalJigyosyo}</span>
              </div>
              <Button
                className={`${styles.closeButton} close tooltip`}
                onClick={() => this.closePopup(this)}
              >
                <Box className={`${styles.description} description`}>閉じる</Box>
                <Close className={`${styles.closeIcon}`} />
              </Button>
            </div>
            {extDiv}
          </div>
          <div className={extDiv ? `${styles.additionalitemcontainer}` : `${styles.additionalitemcontainernoext}`}>
            <CompanyAdditionalItemContensComponent />
          </div>
        </Rnd>
      </div>
    ));
  }
}

export default connect(
  (state) => ({
    additionalItemFlg: state.company.additionalItemFlg,
    additionalCompany: state.company.additionalCompany,
    additionalJigyosyo: state.company.additionalJigyosyo,
    ext001Flg: state.company.ext001Flg,
    ext002Flg: state.company.ext002Flg,
  }),
  (dispatch) => ({
    setAdditionalItemFlgAct: (bool) => dispatch(setAdditionalItemFlg(bool)),
  }),

)(CompanyAdditionalItemListComponent);
